import { Product } from './types';

export const products: Product[] = [
  {
    id: 'craft-dining-table',
    price: 230,
    images: {
      main: '/assets/craft/craft-one.jpg',
      gallery: [
        '/assets/craft/craft-two.webp',
        '/assets/craft/craft-three.jpg'
      ]
    },
    availability: 'In Stock',
    additionalInfo: {
      colors: ['Black'],
    },
    translations: {
      en: {
        title: 'CRAFT Extendable Dining Table',
        description: 'Modern extendable dining table with a durable laminated surface and sturdy metal frame, perfect for both everyday use and entertaining guests.',
        features: [
          'Extendable design (140-180 cm)',
          'Scratch-resistant surface',
          'Metal frame construction',
          'Easy-glide extension mechanism'
        ],
        specifications: {
          dimensions: '140-180L x 90W x 76H cm',
          material: 'Laminated MDF, Powder-coated Metal Frame',
          weight: '41.5 kg (with packaging)',
          finish: 'Matte Black'
        },
        additionalInfo: {
          warranty: '24 months manufacturer warranty',
          assembly: 'Assembly required, instructions included',
          delivery: 'Free delivery within 3-7 business days',
          features: [
            'Synchronized extension system',
            'Adjustable feet for stability',
            'Heat and stain resistant surface',
            'Maximum weight capacity: 100 kg'
          ]
        }
      },
      ru: {
        title: 'CRAFT Раздвижной Обеденный Стол',
        description: 'Современный раздвижной обеденный стол с прочной ламинированной поверхностью и надежной металлической рамой, идеально подходящий как для повседневного использования, так и для приема гостей.',
        features: [
          'Раздвижная конструкция (140-180 см)',
          'Устойчивая к царапинам поверхность',
          'Металлическая конструкция рамы',
          'Механизм легкого скольжения'
        ],
        specifications: {
          dimensions: '140-180Д x 90Ш x 76В см',
          material: 'Ламинированный МДФ, Металлическая рама с порошковым покрытием',
          weight: '41.5 кг (с упаковкой)',
          finish: 'Матовый Черный'
        },
        additionalInfo: {
          warranty: '24 месяца гарантии производителя',
          assembly: 'Требуется сборка, инструкции прилагаются',
          delivery: 'Бесплатная доставка в течение 3-7 рабочих дней',
          features: [
            'Синхронизированная система расширения',
            'Регулируемые ножки для устойчивости',
            'Поверхность, устойчивая к нагреву и пятнам',
            'Максимальная грузоподъемность: 100 кг'
          ]
        }
      },
      lv: {
        title: 'CRAFT Izvelkams Ēdamgalds',
        description: 'Moderns izvelkams ēdamgalds ar izturīgu laminētu virsmu un stabilu metāla rāmi, ideāli piemērots gan ikdienas lietošanai, gan viesu uzņemšanai.',
        features: [
          'Izvelkama konstrukcija (140-180 cm)',
          'Skrāpējumizturīga virsma',
          'Metāla rāmja konstrukcija',
          'Vieglas slīdēšanas mehānisms'
        ],
        specifications: {
          dimensions: '140-180G x 90P x 76A cm',
          material: 'Laminēts MDF, Pulverkrāsots Metāla Rāmis',
          weight: '41.5 kg (ar iepakojumu)',
          finish: 'Matēts Melns'
        },
        additionalInfo: {
          warranty: '24 mēnešu ražotāja garantija',
          assembly: 'Nepieciešama montāža, instrukcijas iekļautas',
          delivery: 'Bezmaksas piegāde 3-7 darba dienu laikā',
          features: [
            'Sinhronizēta paplašināšanas sistēma',
            'Regulējamas kājas stabilitātei',
            'Karstumizturīga un traipizturīga virsma',
            'Maksimālā nestspēja: 100 kg'
          ]
        }
      }
    }
  },
  {
    id: 'iris-stone-table',
    price: 190,
    images: {
      main: '/assets/iris/iris-one.webp',
      gallery: [
        '/assets/iris/iris-two.jpg',
        '/assets/iris/iris-three.jpeg',
      ]
    },
    availability: 'In Stock',
    additionalInfo: {
      colors: ['Black Stone'],
    },
    translations: {
      en: {
        title: 'IRIS Dining Table',
        description: 'Contemporary dining table featuring a stunning stone-effect surface and sleek black metal frame, combining elegance with modern design.',
        features: [
          'Extendable design (110-140 cm)',
          'Stone-effect surface',
          'Black metal frame',
          'Space-saving design'
        ],
        specifications: {
          dimensions: '110-140L x 75W x 76H cm',
          material: 'Stone-effect MDF, Metal Frame',
          weight: '34 kg (with packaging)',
          finish: 'Stone Black'
        },
        additionalInfo: {
          warranty: '24 months manufacturer warranty',
          assembly: 'Partial assembly required, instructions included',
          delivery: 'Free delivery within 3-7 business days',
          features: [
            'Easy-slide extension mechanism',
            'Anti-scratch surface coating',
            'Adjustable feet for uneven floors',
            'Maximum weight capacity: 80 kg'
          ]
        }
      },
      ru: {
        title: 'IRIS Обеденный Стол',
        description: 'Современный обеденный стол с эффектной поверхностью под камень и элегантной черной металлической рамой, сочетающий в себе элегантность и современный дизайн.',
        features: [
          'Раздвижная конструкция (110-140 см)',
          'Поверхность с эффектом камня',
          'Черная металлическая рама',
          'Компактный дизайн'
        ],
        specifications: {
          dimensions: '110-140Д x 75Ш x 76В см',
          material: 'МДФ с эффектом камня, Металлическая рама',
          weight: '34 кг (с упаковкой)',
          finish: 'Черный Камень'
        },
        additionalInfo: {
          warranty: '24 месяца гарантии производителя',
          assembly: 'Требуется частичная сборка, инструкции прилагаются',
          delivery: 'Бесплатная доставка в течение 3-7 рабочих дней',
          features: [
            'Механизм легкого выдвижения',
            'Антицарапинное покрытие поверхности',
            'Регулируемые ножки для неровного пола',
            'Максимальная грузоподъемность: 80 кг'
          ]
        }
      },
      lv: {
        title: 'IRIS Ēdamgalds',
        description: 'Mūsdienīgs ēdamgalds ar iespaidīgu akmens efekta virsmu un eleganto melno metāla rāmi, apvienojot eleganci ar modernu dizainu.',
        features: [
          'Izvelkama konstrukcija (110-140 cm)',
          'Akmens efekta virsma',
          'Melns metāla rāmis',
          'Vietu taupošs dizains'
        ],
        specifications: {
          dimensions: '110-140G x 75P x 76A cm',
          material: 'MDF ar akmens efektu, Metāla Rāmis',
          weight: '34 kg (ar iepakojumu)',
          finish: 'Melns Akmens'
        },
        additionalInfo: {
          warranty: '24 mēnešu ražotāja garantija',
          assembly: 'Nepieciešama daļēja montāža, instrukcijas iekļautas',
          delivery: 'Bezmaksas piegāde 3-7 darba dienu laikā',
          features: [
            'Vieglas izvilkšanas mehānisms',
            'Skrāpējumizturīgs virsmas pārklājums',
            'Regulējamas kājas nelīdzenām grīdām',
            'Maksimālā nestspēja: 80 kg'
          ]
        }
      }
    }
  }
];